export default __webpack_public_path__ + "static/project-4d0c286183ac6cded812890a9e0d1337.png";